import ModalSuccess from './modal-success';

export default ModalSuccess;
